// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__I_RKz","small":"Button_small__SB33v","medium":"Button_medium__dCSnw","large":"Button_large__keb9L","mobile":"Button_mobile__JkLP9"};